export function serviceVisitToForm(item) {
  const items = item.items || [];
  const serviceTypeItems = items.filter(task => task.type === "service_type");
  const signalItems = items.filter(
    task => task.type === "machine_service_signal"
  );
  const customTaskItems = items.filter(task => task.type === "custom_task");
  const isOnRoad = isServiceVisitOnRoad(item);

  return {
    machineId: item.machineId,
    statusId: item.statusId,
    priorityId: item.priorityId,
    isOnRoad,
    onRoadNote: isOnRoad ? item.onRoadNote || null : null,
    serviceLocationId: isOnRoad ? null : item.serviceLocationId || null,
    dateFrom: item.dateFrom,
    dateTo: item.dateTo,
    duration: item.duration,
    serviceMileage: item.serviceMileage,
    hoursWorked: item.hoursWorked,
    workDone: item.workDone,
    mechanicIds: (item.mechanics || []).map(mechanic => mechanic.id),
    serviceTypeIds: serviceTypeItems.map(task => task.itemableId),
    serviceTypeNotes: serviceTypeItems.reduce((notes, task) => {
      notes[task.itemableId] = task.note || "";
      return notes;
    }, {}),
    serviceTypeStatusIds: serviceTypeItems.reduce((statuses, task) => {
      statuses[task.itemableId] = task.statusId || (task.status && task.status.id) || null;
      return statuses;
    }, {}),
    machineServiceSignalIds: signalItems.map(task => task.itemableId),
    machineServiceSignalNotes: signalItems.reduce(
      (notes, task) => {
        notes[task.itemableId] = task.note || "";
        return notes;
      },
      {}
    ),
    machineServiceSignalStatusIds: signalItems.reduce(
      (statuses, task) => {
        statuses[task.itemableId] = task.statusId || (task.status && task.status.id) || null;
        return statuses;
      },
      {}
    ),
    customTasks: customTaskItems.map(task => ({
      id: task.itemableId,
      description: task.name,
      statusId: task.statusId || (task.status && task.status.id) || null,
      note: task.note || ""
    }))
  };
}

export function serviceVisitFormPayload(
  form,
  includeCustomTaskIds = true,
  defaultItemStatusId = null
) {
  const payload = JSON.parse(JSON.stringify(form));
  payload.isOnRoad = Boolean(payload.isOnRoad);
  payload.onRoadNote = payload.isOnRoad ? payload.onRoadNote || null : null;
  payload.serviceLocationId = payload.isOnRoad
    ? null
    : payload.serviceLocationId || null;
  payload.serviceMileage =
    payload.serviceMileage === "" || payload.serviceMileage === null
      ? null
      : Number(payload.serviceMileage);
  payload.hoursWorked =
    payload.hoursWorked === "" || payload.hoursWorked === null
      ? null
      : Number(payload.hoursWorked);
  payload.workDone = payload.workDone ? payload.workDone.trim() : null;

  payload.serviceTypeItems = (payload.serviceTypeIds || []).map(id => ({
    id,
    statusId: (payload.serviceTypeStatusIds || {})[id] || defaultItemStatusId,
    note: (payload.serviceTypeNotes || {})[id] || null
  }));

  payload.machineServiceSignalItems = (
    payload.machineServiceSignalIds || []
  ).map(id => ({
    id,
    statusId:
      (payload.machineServiceSignalStatusIds || {})[id] || defaultItemStatusId,
    note: (payload.machineServiceSignalNotes || {})[id] || null
  }));

  payload.customTasks = (payload.customTasks || []).map(customTask => {
    const data = {
      description: customTask.description,
      statusId: customTask.statusId || defaultItemStatusId,
      note: customTask.note || null
    };

    if (includeCustomTaskIds && customTask.id) {
      data.id = customTask.id;
    }

    return data;
  });

  delete payload.serviceTypeNotes;
  delete payload.serviceTypeStatusIds;
  delete payload.machineServiceSignalNotes;
  delete payload.machineServiceSignalStatusIds;
  delete payload.serviceTypeIds;
  delete payload.machineServiceSignalIds;
  delete payload.serviceLocationTypeId;
  delete payload.outsideServiceId;
  delete payload.serviceLocation;

  return payload;
}

export function serviceVisitListParams(params) {
  const sortBy = Array.isArray(params.sortBy) ? params.sortBy[0] : params.sortBy;
  const sortDesc = Array.isArray(params.sortDesc)
    ? params.sortDesc[0]
    : params.sortDesc;

  return {
    ...params,
    sortBy,
    sortDesc
  };
}

export function serviceVisitLocationText(item, onRoadLabel = "On road") {
  if (!item) {
    return "";
  }

  if (isServiceVisitOnRoad(item)) {
    return onRoadLabel;
  }

  const serviceLocation = item.serviceLocation;
  if (!serviceLocation) {
    return "";
  }

  if (typeof serviceLocation === "string") {
    return serviceLocation;
  }

  return [serviceLocation.name, serviceLocation.location]
    .filter(Boolean)
    .join(" | ");
}

export function isServiceVisitOnRoad(item) {
  if (!item) {
    return false;
  }

  const value = item.isOnRoad;

  return value === true || value === 1 || value === "1" || value === "true";
}

export function isServiceVisitFinished(item) {
  return Boolean(item && item.status && item.status.slug === "finished");
}
